// @flow
import { ConnectTierPricingTable } from '@components/connect-tier-pricing/ConnectTierPricingTable';
import { TableflowTierPricingTable } from '@components/tableflow-tier-pricing/TableflowTierPricingTable';
import React from 'react';

// Hierarchy: metric name -> dimension name -> special config
export const CUSTOM_DISCOUNTS_SPECIAL_CONFIG = {
  ConnectNumTasksTiered: {
    tier: {
      // Metronome does not support the 'all' value for the 'tier' dimension, so we hide the ALL dropdown option for now.
      doNotAddAllDropdownOption: true,
      specialDependentDimensionProps: {
        headerTooltip: <ConnectTierPricingTable />,
      },
    },
  },
  TableflowNumTopicsTiered: {
    tier: {
      // Metronome does not support the 'all' value for the 'tier' dimension, so we hide the ALL dropdown option for now.
      doNotAddAllDropdownOption: true,
      specialDependentDimensionProps: {
        headerTooltip: <TableflowTierPricingTable />,
      },
    },
  },
};
